const operators = [
  {
    name: '=',
    classes: ['compare', 'binary', 'infix', 'bool'],
    left: 'column',
    right: 'const',
    compute(left, right) {
      if(left && right && left.toLowerCase && right.toLowerCase)
        return left.toLowerCase() == right.toLowerCase()
      return left == right
    },
    defaultArgs(columns) {
      return [columns[1] || columns[0], 0]
    }
  },
  {
    name: 'regex',
    classes: ['compare', 'binary', 'infix', 'bool'],
    left: 'column',
    right: 'regex',
    compute(left, right) {
      return (""+left).match(right)
    },
    defaultArgs(columns) {
      return [columns[1] || columns[0], 0]
    }
  },
  {
    name: '!regex',
    classes: ['compare', 'binary', 'infix', 'bool'],
    left: 'column',
    right: 'regex',
    compute(left, right) {
      return !((""+left).match(right))
    },
    defaultArgs(columns) {
      return [columns[1] || columns[0], 0]
    }
  },
  {
    name: '<=',
    classes: ['compare', 'binary', 'infix', 'bool'],
    left: 'column',
    right: 'const',
    compute(left, right) {
      return left <= right
    },
    defaultArgs(columns) {
      return [columns[1] || columns[0], 0]
    }
  },
  {
    name: '>=',
    left: 'column',
    right: 'const',
    classes: ['compare', 'binary', 'infix', 'bool'],
    compute(left, right) {
      return left >= right
    },
    defaultArgs(columns) {
      return [columns[1] || columns[0], 0]
    }
  },
  {
    name: '<',
    left: 'column',
    right: 'const',
    classes: ['compare', 'binary', 'infix', 'bool'],
    compute(left, right) {
      return left < right
    },
    defaultArgs(columns) {
      return [columns[1] || columns[0], 0]
    }
  },
  {
    name: '>',
    left: 'column',
    right: 'const',
    classes: ['compare', 'binary', 'infix', 'bool'],
    compute(left, right) {
      //console.log("COMPUTE >", left, right)
      return left > right
    },
    defaultArgs(columns) {
      return [columns[1] || columns[0], 0]
    }
  },
  {
    name: 'and',
    element: 'bool',
    classes: ['logical', 'list', 'infix', 'bool'],
    compute(args) {
      return args.reduce((a, b) => a && b, true)
    },
    defaultArgs(columns) {
      return [
        {
          "type": ">",
          "args": ["Count", 100]
        }
      ]
    }
  },
  {
    name: 'nand',
    element: 'bool',
    classes: ['logical', 'list', 'infix', 'bool'],
    compute(args) {
      return !args.reduce((a, b) => a && b, true)
    },
    defaultArgs(columns) {
      return [
        {
          "type": "<",
          "args": ["Count", 100]
        }
      ]
    }
  },
  {
    name: 'or',
    element: 'bool',
    classes: ['logical', 'list', 'infix', 'bool'],
    compute(args) {
      return args.reduce((a, b) => a || b, false)
    },
    defaultArgs(columns) {
      return []
    }
  }
]

const classes = ['logical', 'compare', 'arithmetic', 'unary', 'binary', 'list', 'infix', 'prefix']

const operatorsByName = new Map()

for(let definition of operators) {
  definition.title = definition.name.slice(0, 1).toUpperCase() + definition.name.slice(1)
  for(const clazz of classes) definition['is' + clazz.slice(0, 1).toUpperCase() + clazz.slice(1)] = false
  for(const clazz of definition.classes) definition['is' + clazz.slice(0, 1).toUpperCase() + clazz.slice(1)] = true
  operatorsByName.set(definition.name, definition)
}

function newArg(at, columns) {
  const definition = operatorsByName.get(at.type)
  if(definition.isList) {
    switch(definition.element)  {
      case 'bool' : return {
        type: ">",
        args: [
          columns[1] || columns[0],
          0
        ]
      }
    }
  }
  return {
    type: "and",
    args: []
  }
}

function prepareColumn(arg) {
  if(Number.isNaN(+arg)) return arg;
  return +arg
}

function prepareConst(arg) {
  if(Number.isNaN(+arg)) return arg;
  return ((+arg) * 100) | 0
}

function prepareRegex(arg) {
  return new RegExp(arg, "ig")
}

function compileFilter(filter, columnIdByName) {
  const declaration = operatorsByName.get(filter.type)
  console.log("COMPILE FILTER", filter.type, declaration, operatorsByName)
  if(declaration.isBinary) {
    let fetchLeft
    if(declaration.left == 'column') {
      const leftColumnId = columnIdByName.get(filter.args[0])
      fetchLeft = row => prepareColumn(row[leftColumnId])
    }
    if(declaration.left == 'const') {
      fetchLeft = row => prepareConst(filter.args[0])
    }
    if(declaration.left == 'regex') {
      fetchLeft = row => prepareRegex(filter.args[0])
    }
    let fetchRight
    if(declaration.right == 'column') {
      const rightColumnId = columnIdByName.get(filter.args[1])
      fetchRight = row => prepareColumn(row[rightColumnId])
    }
    if(declaration.right == 'const') {
      fetchRight = row => prepareConst(filter.args[1])
    }
    if(declaration.right == 'regex') {
      fetchRight = row => prepareRegex(filter.args[1])
    }
    return row => {
      let r = declaration.compute(fetchLeft(row), fetchRight(row))
      return r
    }
  }
  if(declaration.isList) {
    let fetchArgs = filter.args.map(arg => compileFilter(arg, columnIdByName))
    return row => declaration.compute(fetchArgs.map(fArg => fArg(row)))
  }
  if(declaration.isOpList) {
    let fetchArgs = filter.args.map(arg => compileFilter(arg, columnIdByName))
    return row => declaration.compute(fetchArgs.map(fArg => fArg(row)), filter.ops)
  }
}

export default {
  classes,
  operators,
  operatorsByName,
  newArg,
  compileFilter
}



// WEBPACK FOOTER //
// ./src/logic/expression.js